import { ExecutionRequestStatus } from "@/lib/interfaces and Enums/ENUMExecutionRequestStatus";
import { ExecutionStrategyStatus } from "@/lib/interfaces and Enums/ENUMExecutionStrategyStatus";
import { Role } from "@/lib/interfaces and Enums/ENUMRole";
import { ICustomCellRendererProps } from "@/lib/interfaces and Enums/InterfaceCustomCellRenderer";
import { IExecutionRequestCounterParties } from "@/lib/interfaces and Enums/InterfaceExecutionRequestCounterParties";

const StatusCellRenderer = (params: ICustomCellRendererProps) => {
  if (params.data == undefined) {
    return;
  }
  const statusToRender = params.value;

  let fractionQuoted = "";

  if (params.data.role == Role.OP && params.data.executionRequestCounterParties) {
    if (params.value == ExecutionStrategyStatus.Quoted) {
      const totalCounterparties =
        params.data.executionRequestCounterParties.length;
      let quotedCounterparties = 0;
      params.data.executionRequestCounterParties.forEach(
        (counterparty: any) => {
          if (counterparty.order != 9999) {
            quotedCounterparties++;
          }
        },
      );
      fractionQuoted = `${quotedCounterparties}/${totalCounterparties}`;
    }
    if (
      params.value == ExecutionStrategyStatus.Sent ||
      params.value == ExecutionStrategyStatus.ReSent
    ) {
      const totalCounterparties =
        params.data.executionRequestCounterParties.length;
      const totalCounterpartiesReceived =
        params.data.executionRequestCounterParties.filter(
          (cp: IExecutionRequestCounterParties) => {
            return (
              cp.status == ExecutionRequestStatus.ReSent ||
              cp.status == ExecutionRequestStatus.Received
            );
          },
        ).length;

      if (totalCounterparties > 0) {
        fractionQuoted = `${totalCounterpartiesReceived}/${totalCounterparties}`;
      }
    }
  }

  return (
    <div className="w-full cursor-pointer">
      {statusToRender} {fractionQuoted}
    </div>
  );
};

export default StatusCellRenderer;
